module.exports = __webpack_public_path__ + "static/3cd75441706cb8a7fea267222fa09a044370f495a033f50806a72a28468ba5d6-57f5d07bc0044e4e13669c397db9f3ef.png";